import { render, staticRenderFns } from "./ContentPreviewModal.vue?vue&type=template&id=5af449f5&scoped=true"
import script from "./ContentPreviewModal.vue?vue&type=script&lang=js"
export * from "./ContentPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ContentPreviewModal.vue?vue&type=style&index=0&id=5af449f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af449f5",
  null
  
)

export default component.exports